import { Nullable } from 'shared_DEPRECATED/types';
import { Picture } from 'shared_DEPRECATED/types/Picture';

import { ChallengeTimelineItemType } from 'features/challenge/ChallengeTimelineItem';
import { createChallenge } from 'features/challenge/utils/challengeUtils';
import {
  FocusAreasType,
  GOAL_DEEP_DIVE_DEFAULT_VALUE,
  GoalDeepDiveType,
  IGoal,
} from 'features/goal';

export class Goal implements IGoal {
  challenges: ChallengeTimelineItemType[];
  focusAreas: FocusAreasType;
  readonly goalId: string;
  readonly columnId: string;
  readonly columnLabel: string;
  readonly createdAt?: string;
  readonly completedAt: Nullable<string>;
  readonly cover: Nullable<Picture>;
  name: string;
  deadline: Nullable<string>;
  dimensions: string[];
  deepDive: GoalDeepDiveType;
  deepDiveAvailable: boolean;
  note: string;
  prioritizedAt: Nullable<string>;
  title: string;
  private: boolean;
  prioritized: boolean;

  constructor(goal: IGoal) {
    this.challenges = goal.challenges.map(createChallenge);
    this.focusAreas = goal.focusAreas.map((focusArea) => ({
      ...focusArea,
      challenges: focusArea.challenges.map(createChallenge),
    }));
    this.goalId = goal.goalId;
    this.columnId = goal.columnId;
    this.columnLabel = goal.columnLabel;
    this.name = goal.name;
    this.deadline = goal.deadline;
    this.dimensions = goal.dimensions;
    this.deepDive = goal.deepDive || GOAL_DEEP_DIVE_DEFAULT_VALUE;
    this.deepDiveAvailable = goal.deepDiveAvailable;
    this.createdAt = goal.createdAt;
    this.completedAt = goal.completedAt;
    this.cover = goal.cover;
    this.note = goal.note;
    this.prioritizedAt = goal.prioritizedAt;
    this.title = goal.title;
    this.private = goal.private;
    this.prioritized = goal.prioritized;
  }
}
